var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.75C14.62 11.75 16.75 9.62 16.75 7C16.75 4.38 14.62 2.25 12 2.25C9.38 2.25 7.25 4.38 7.25 7C7.25 9.62 9.38 11.75 12 11.75ZM12 3.75C13.79 3.75 15.25 5.21 15.25 7C15.25 8.79 13.79 10.25 12 10.25C10.21 10.25 8.75 8.79 8.75 7C8.75 5.21 10.21 3.75 12 3.75ZM15 13.25H9C5.83 13.25 3.25 15.83 3.25 19C3.25 20.52 4.48 21.75 6 21.75H18C19.52 21.75 20.75 20.52 20.75 19C20.75 15.83 18.17 13.25 15 13.25ZM18 20.25H6C5.31 20.25 4.75 19.69 4.75 19C4.75264 17.8736 5.20126 16.7942 5.99771 15.9977C6.79417 15.2013 7.87364 14.7526 9 14.75H15C16.1264 14.7526 17.2058 15.2013 18.0023 15.9977C18.7987 16.7942 19.2474 17.8736 19.25 19C19.25 19.69 18.69 20.25 18 20.25Z",
    fill: "#496683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.0cde9186772aba129c12f5283a55a0d7.svg";
export { ForwardRef as ReactComponent };